import { render } from "./MyRecentPatients.vue?vue&type=template&id=5ec9c13d&scoped=true&ts=true"
import script from "./MyRecentPatients.vue?vue&type=script&lang=ts"
export * from "./MyRecentPatients.vue?vue&type=script&lang=ts"

import "./MyRecentPatients.vue?vue&type=style&index=0&id=5ec9c13d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec9c13d"]])

export default __exports__